import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { PIE_COLORS } from '../../Helpers/ChartConstants'
import ChartUtility from '../../Helpers/ChartUtility.js'
import updateViewAllHoldingsLink from '../../Helpers/UpdateViewAllHoldingsLink.js'
import { formatDateStandard } from '../../../../global/formatters/string-formatter'
import { monthMap } from '../../../../spa/utility/dates/dates.js'
import { getFullHoldings } from '../../../../spa/components/investmentProducts/InvestmentProductsDataSource'
import { isIntervalFund } from '../../Helpers/CheckProductType'

class PortfolioTopHoldings extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedInterval: 0,
    }
  }

  componentDidMount() {
    this.checkTopHoldingWeightPercent()
    updateViewAllHoldingsLink()
  }

  componentDidUpdate() {
    this.checkTopHoldingWeightPercent()
    updateViewAllHoldingsLink()
  }

  checkTopHoldingWeightPercent() {
    const { topHoldings } = this.props.topHoldingDetail
    const selectedData = topHoldings[this.state.selectedInterval]

    if (
      selectedData.topHoldingWeightPercent &&
      selectedData.topHoldingWeightPercent <= 100
    ) {
      this.renderPieChart(selectedData.topHoldingWeightPercent)
    }
  }

  onClickDownloadAllHoldings = (event) => {
    event.preventDefault()

    const cusip = this.props.fund.cusip
    const { topHoldings } = this.props.topHoldingDetail
    const interval = topHoldings[this.state.selectedInterval].holdingInterval
    const month = monthMap[interval.split(' ')[0]]
    const period = month + interval.split(' ')[1]

    const _url = getFullHoldings(cusip, period)

    window.location = _url
  }

  handleIntervalChange = (event) => {
    const { topHoldingsIntervals } = this.props.topHoldingDetail
    const { value } = event.target || {}

    this.setState({
      selectedInterval: topHoldingsIntervals.indexOf(value),
    })
  }

  renderTopHoldingsDropdown = (holdingsIntervals) => {
    return (
      <div
        className="Dropdown date-dropdown-template"
        id="top-holdings-date-dropdown"
      >
        <select
          className="Dropdown-menu"
          onChange={this.handleIntervalChange.bind(this)}
        >
          {holdingsIntervals.map((item) => {
            return (
              <option key={item} value={item}>
                {item}
              </option>
            )
          })}
        </select>
      </div>
    )
  }

  renderTopHoldings(topHoldingsDetails) {
    const selectedData = topHoldingsDetails[this.state.selectedInterval]
    if (
      selectedData.topHoldingWeightPercent &&
      selectedData.topHoldingWeightPercent <= 100
    ) {
      return (
        <div className="Grid u-sm-flexColReverse">
          <div
            id="top-holdings-table"
            className="u-size6of12 u-flexGrow5 u-sm-sizeFull"
          >
            {this.renderTopHoldingsTable(selectedData)}
          </div>
          <div id="top-holdings-body" className="u-size6of12 u-sm-sizeFull">
            {this.renderTopHoldingsGraph(selectedData)}
          </div>
        </div>
      )
    } else {
      return (
        <div className="Grid u-sm-flexColReverse">
          <div id="top-holdings-table" className="u-size12of12 u-sm-sizeFull">
            {this.renderTopHoldingsTable(selectedData)}
          </div>
        </div>
      )
    }
  }

  renderTopHoldingsTable(row) {
    return (
      <table className="Table Table--reversed Table--striped">
        <thead className="Table-head">
          <tr className="Table-row">
            <th className="Table-header u-alignMiddle tableHeader">Holding</th>
            <th className="Table-header u-alignMiddle u-textRight tableHeader">
              Fund
            </th>
            <th className="Table-header u-alignMiddle u-textRight tableHeader">
              {row.benchmarkName}
            </th>
          </tr>
        </thead>
        <tbody className="Table-body">
          {this.renderTopHoldingsRows(row)}
          <tr className="Table-row" key={'view-all-holdings-link'}>
            <td className="Table-cell">
              <div>
                <a className="js-full-holdings-link" href="#">
                  View all holdings
                </a>
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    )
  }

  renderTopHoldingsRows({ holdings }) {
    return holdings.map((item, i) => {
      return (
        <tr className="Table-row" key={item.holdingName + i}>
          <td className="Table-cell">
            <div>{item.holdingName}</div>
          </td>
          <td className="Table-cell u-textRight">
            <div>{item.fundWeightPercent}</div>
          </td>
          <td className="Table-cell u-textRight">
            <div>{item.indexWeightPercent}</div>
          </td>
        </tr>
      )
    })
  }

  renderTopHoldingsGraph(rowData) {
    return (
      <table className="js-total-holdings-pie-table Table Table--reversed">
        <thead className="Table-head">
          <tr className="Table-row">
            <th className="Table-header u-alignMiddle u-textCenter tableHeader">
              Fund Weighting (%)
            </th>
          </tr>
        </thead>
        <tbody className="Table-body">
          <tr className="Table-row">
            <td className="Table-cell u-paddingHoriz10gu u-textCenter">
              <div id="top-holdings-pie-chart"></div>
              The top holdings comprise{' '}
              <strong>{rowData.topHoldingWeightPercent}%</strong> of the
              fund&rsquo;s <strong>{rowData.numberOfHoldings}</strong> total
              holdings.
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  renderPieChart = (topHoldingWeightPercent) => {
    let topHoldingsValue = Number(topHoldingWeightPercent)

    // IEEE754 floating point 32 bit float problem. Can't just simply subtract instead of: x - y, we are doing: (Ax - Ay) / A
    // where A is a multiplier that turns the decimal number into an integer
    let MULTIPLIER = 1000
    let otherHoldingsValue =
      Number(MULTIPLIER * 100 - MULTIPLIER * Number(topHoldingWeightPercent)) /
      MULTIPLIER
    let chartUtility = new ChartUtility()

    chartUtility.renderPieChart(
      'top-holdings',
      [
        {
          name: 'Top Holdings',
          y: topHoldingsValue,
        },
        {
          name: 'Other Holdings',
          y: otherHoldingsValue,
        },
      ],
      {
        colors: [PIE_COLORS.PIE_COLOR_PRIMARY, PIE_COLORS.PIE_COLOR_OTHER],
      }
    )
  }

  render() {
    const { topHoldings, topHoldingsDisclosure, topHoldingsIntervals } =
      this.props.topHoldingDetail

    const selectedData = topHoldings[this.state.selectedInterval]
    const { holdingLabel, holdingAsOfDate } = selectedData

    return (
      <div id="top-holdings">
        <div
          id="ampf-trace-loaded-section-portfolio-details-top-holdings"
          className="u-paddingBottom4gu u-paddingTop4gu"
        >
          <div className="Content">
            <div className="Grid Grid--alignMiddle u-flexJustifyBetween u-marginBottom4gu">
              <div className="Content u-sizeFit u-sm-marginBottom3gu u-sm-sizeFull">
                <h3 className="u-marginVert0" id="top-holdings-title">
                  {holdingLabel}{' '}
                  <span className="u-sm-block u-sm-paddingTop1gu">
                    as of {formatDateStandard(holdingAsOfDate)}
                  </span>
                </h3>
              </div>
              {isIntervalFund(this.props.fund.fundGroup) ? (
                <div className="Grid Grid--alignMiddle u-sizeFit">
                  {/* hide download button for full holdings until data issue is resolved*/}
                  {/* <div className="u-sizeFit u-sm-sizeFull">
                    <button
                      className="Button Button--tertiary u-padding2gu u-textNoTransform"
                      onClick={this.onClickDownloadAllHoldings}
                      data-analytics="download-cap-gains-distributions-landing"
                    >
                      Download all holdings (csv)
                    </button>
                  </div> */}
                  <div className="u-sizeFit u-sm-sizeFull">
                    {this.renderTopHoldingsDropdown(topHoldingsIntervals)}
                  </div>
                </div>
              ) : (
                <div className="u-sizeFit u-sm-sizeFull">
                  {this.renderTopHoldingsDropdown(topHoldingsIntervals)}
                </div>
              )}
            </div>

            {this.renderTopHoldings(topHoldings)}

            <div
              className="Disclaimer u-marginTop4gu"
              data-qa-automation="top-holdings-disclosure"
            >
              <h5 className="Disclaimer-heading">Top Holdings Disclosure</h5>
              <div
                className="Disclaimer-text"
                dangerouslySetInnerHTML={{ __html: topHoldingsDisclosure }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
PortfolioTopHoldings.propTypes = {
  topHoldingDetail: PropTypes.object,
  fund: PropTypes.object,
}

export default PortfolioTopHoldings
